export default __webpack_public_path__ + "media/dc45e72983cbda1d6fd94441b57bc1b6a3a424a94c6412ae2361053e08b4ff54.svg";